/**
 * Putt Broadie Drill 5FT Reducers
 */
import {
    PUTTBDFIVEPOINTS_ACTION,
    ALL_PUTTBDFIVEPOINTS,
    ADD_PUTTBDFIVEPOINTS,
    ALL_PUTTBDFIVEPUTTS,
    ADD_PUTTBDFIVEPUTTS,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    puttbdfivepointlist:[],
    puttbdfiveputtlist:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PUTTBDFIVEPOINTS_ACTION:
            return { ...state, loading: true };       

        case ALL_PUTTBDFIVEPOINTS:
            return { ...state, loading: false, puttbdfivepointlist: action.payload };     
            
        case ADD_PUTTBDFIVEPOINTS:
            return { ...state, loading: false }; 
            
        case ALL_PUTTBDFIVEPUTTS:
            return { ...state, loading: false, puttbdfiveputtlist: action.payload };     
            
        case ADD_PUTTBDFIVEPUTTS:
            return { ...state, loading: false }; 

        default: return { ...state };

     }
 }